// extracted by mini-css-extract-plugin
export var closed = "_al-1";
export var resizer = "_al-0";